import { render, staticRenderFns } from "./CustomLabelUpdate.vue?vue&type=template&id=2dcc3749&scoped=true&"
import script from "./CustomLabelUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomLabelUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CustomLabelUpdate.vue?vue&type=style&index=0&id=2dcc3749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc3749",
  null
  
)

export default component.exports